import { render, staticRenderFns } from "./TransferParent.vue?vue&type=template&id=488be0c6"
import script from "./TransferParent.vue?vue&type=script&lang=ts"
export * from "./TransferParent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports